export const ensureIsArray = <T>(array?: T[]): T[] => (!!array ? array : []);

export const filterTruthy = <T>(array: T[]): T[] =>
  array.filter((value) => !!value);

export const getLastInArray = <T>(array: T[]): T | undefined =>
  array.slice(-1)[0];

// Array
export const getFirstInArray = <T>(array?: T[]): T | undefined =>
  !!array && array.length > 0 ? array[0] : undefined;

const getLengthsOfArrays = <T>(...arrays: Array<T[]>) => {
  return arrays.map((a) => a.length);
};
export const getLengthOfLongestArray = <T>(
  ...arrays: Array<T[]>
): number | undefined => {
  return getLastInArray(getLengthsOfArrays(arrays).sort((n1, n2) => n1 - n2));
};

export const getLengthOfShortestArray = <T>(
  ...arrays: Array<T[]>
): number | undefined => {
  return getFirstInArray(getLengthsOfArrays(arrays).sort((n1, n2) => n1 - n2));
};
